import React from 'react';

import { HelpRounded } from '@material-ui/icons';

import cn from '../../../utils/cn';

export interface PopoverIconProps {
  icon?: React.ReactNode;
  className?: string;
}

const PopoverIcon = ({ icon, className, ...props }: PopoverIconProps) => {
  return icon ? (
    React.cloneElement(icon as React.ReactElement, {
      ...props,
      className: cn(
        '!h-4 !w-4 text-gray !transition-all !duration-300 !ease-in-out  hover:text-gray-black data-[state=open]:text-gray-dark',
        className
      ),
    })
  ) : (
    <HelpRounded
      {...props}
      className={cn(
        '!h-4 !w-4 text-gray !transition-all !duration-300 !ease-in-out hover:text-gray-dark data-[state=open]:text-gray-dark',
        className
      )}
    />
  );
};

PopoverIcon.displayName = 'Popover.Icon';

export default PopoverIcon;
